import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonToggle, MatButtonToggleGroup, MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatPseudoCheckboxModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';
import { StatusBusinessPartnerEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/status-business-partner.enum';
import { SubRouteModelEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/sub-route-model.enum';
import { getTripStatusConfig, TRIP_STATUS_CONFIG } from '../../../../common/enums/trip-status.enum';
import { TripStatusIconComponent } from '../../../../shared/components/trip-status-icon/trip-status-icon.component';
import { TemporaryPasswordStatus } from 'app/shared/enums/status-temporary-password.enum';
@Component({
  selector: "app-status-filters",
  standalone: true,
  imports: [
    CommonModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatIconModule,
    MatPseudoCheckboxModule,
    MatButtonToggleGroup,
    MatDividerModule,
    TripStatusIconComponent,
  ],
  templateUrl: "./status-filters.component.html",
  styleUrl: "./status-filters.component.scss",
})
export class StatusFiltersComponent {
  @Input() selectedStatuses: number[] = [];
  @Input() selectedStatusesBankType: string[] = [];
  @Input() selectedERPStatuses: number[] = [];
  @Input() selectedCustomerType: string[] = [];
  @Input() selectedStatusNewBP: number[] = [];
  @Input() selectedStatusRequestCredit: boolean[] = [];
  @Input() showTreeMode: boolean = false;
  @Input() showTreeModeUnit: boolean = false;
  @Input() showTreeModeMonitor: boolean = false;
  @Input() modeTree: "territory" | "salesOffice" | "group" | null = null;
  @Input() modeTreeUnit: "group" | null = null;
  @Input() modeTreeMonitor: "statusTrip" | "functionTrip" | null = null;
  @Input() showStatus: number[] = [];
  @Input() showStatusBankType: boolean = false;
  @Input() showERPStatus: number[] = [];
  @Input() showCustomerType: string[] = [];
  @Input() showStatusNewBP: number[] = [];
  @Input() active: boolean = false;
  @Input() typeFilter: string = "order";
  @Input() showRequestCredit: boolean = false;

  //estados de viaje
  @Input() selectedTripStatuses: number[] = [];
  @Input() showTripStatuses: number[] = [];
  @Input() selectedRouteFunction: string[] = [];
  @Input() showRouteFunction: boolean = false;
  @Input() tripStatusOptions: any[] = [];
  @Input() routeFunctionOptions: any[] = [];

  @Output() selectionFilterApply = new EventEmitter<void>();
  @Output() selectionFilterApplyTree = new EventEmitter<void>();
  @Output() applyFilterTreeMonitor = new EventEmitter<void>();

  statusOptions = [];
  erpStatusOptions = [];
  erpCustomerOptions = [];
  statusNewBPOptions = [];
  statusBankType = [];
  statusRequestCredit = [];

  @ViewChild("toggleGroup") toggleGroup!: MatButtonToggleGroup;

  // Si count es 0/undefined, desmarcamos inmediatamente
  resetIfEmpty(toggle: MatButtonToggle, count?: number) {
    if (!count) {
      toggle.checked = false;
      // Si el grupo tomó el valor, lo limpiamos
      if (this.toggleGroup) {
        const current = this.toggleGroup.value;
        if (Array.isArray(current)) {
          this.toggleGroup.value = current.filter((v) => v !== toggle.value);
        } else if (current === toggle.value) {
          this.toggleGroup.value = null;
        }
      }
    }
  }

  statusNewBP = Object.keys(StatusBusinessPartnerEnum)
    .filter((key) => isNaN(Number(key)))
    .map((key) => ({
      label: this.getStatusLabelNewBP(
        StatusBusinessPartnerEnum[key as keyof typeof StatusBusinessPartnerEnum]
      ),
      value:
        StatusBusinessPartnerEnum[
          key as keyof typeof StatusBusinessPartnerEnum
        ],
    }));

  treeModesList = [
    { value: null, label: "Por Defecto" },
    { value: "salesOffice", label: "Oficina de Venta" },
    { value: "territory", label: "Territorio" },
    { value: "group", label: "Grupo de Ruta" },
  ];

  treeModestListUnit = [
    { value: null, label: "Por Defecto" },
    { value: "group", label: "Grupo de Unidad" },
  ];

  treeModesListMonitor = [
    { value: null, label: "Por Defecto" },
    { value: "statusTrip", label: "Estado de viaje" },
    { value: "functionTrip", label: "Funcion de Viaje" },
  ];

  statusTemporaryPassword = [
    { value: TemporaryPasswordStatus.CURRENT, 
      label: "Vigente", 
      icon: "heroicons_solid:check-circle",
      color: "rgb(9, 133, 50)",
    },
    { value: TemporaryPasswordStatus.USED, 
      label: "Usada", 
      icon: "heroicons_solid:check",
      color: "rgb(236, 199, 58)" },
    { value: TemporaryPasswordStatus.REVOKED, 
      label: "Revocada",
      icon: "heroicons_solid:x-circle",
      color: "rgb(255, 136, 0)"
    },
    { value: TemporaryPasswordStatus.EXPIRED, 
      label: "Exirada",
      icon: "heroicons_solid:x-circle",
      color: "rgb(141, 19, 19)" },
  ];

  statusChanges = [
    {
      value: 1,
      label: "Activo",
      icon: "heroicons_solid:check-circle",
      color: "rgb(65, 106, 218)",
    },
    {
      value: 0,
      label: "Anulado",
      icon: "heroicons_solid:x-circle",
      color: "rgb(141, 19, 19)",
    },
    {
      value: 6,
      label: "En progreso",
      icon: "heroicons_solid:play-circle",
      color: "rgb(236, 199, 58)",
    },
    {
      value: 7,
      label: "Aprobado",
      icon: "heroicons_solid:check-circle",
      color: "rgb(9, 133, 50)",
    },
    {
      value: 14,
      label: "Aprobado Parcialmente",
      icon: "heroicons_solid:check-circle",
      color: "rgb(102, 205, 170)",
    },
    {
      value: 8,
      label: "Rechazado",
      icon: "heroicons_solid:x-circle",
      color: "rgb(255, 0, 0)",
    },
    {
      value: 18,
      label: "Inactivo por falta de inventario",
      icon: "heroicons_solid:no-symbol",
      color: "rgb(255, 0, 0)",
    },
    {
      value: 9,
      label: "Entregado completamente al cliente",
      icon: "mat_solid:checklist_rtl",
      color: "rgb(9, 133, 50)",
    }, // se debe manejar para devolución, verificar el enum
    {
      value: 10,
      label: "Entregado parcialmente al cliente",
      icon: "mat_solid:check",
      color: "rgb(255, 136, 0)",
    }, // se debe manejar para devolución, verificar el enum
    {
      value: 11,
      label: "Entrega rechazada por el cliente",
      icon: "mat_solid:indeterminate_check_box",
      color: "rgb(255, 55, 0)",
    }, // se debe manejar para devolución, verificar el enum
    {
      value: 17,
      label: "Orden finalizada",
      icon: "heroicons_solid:x-circle",
      color: "rgb(255, 0, 0)",
    },
  ];

  statusCharges = [
    {
      value: 0,
      label: "Anulado",
      icon: "heroicons_solid:x-circle",
      color: "rgb(141, 19, 19)",
    },
    {
      value: 6,
      label: "En progreso",
      icon: "heroicons_solid:play-circle",
      color: "rgb(236, 199, 58)",
    },
    {
      value: 7,
      label: "Aceptado",
      icon: "heroicons_solid:check-circle",
      color: "rgb(9, 133, 50)",
    },
    {
      value: 8,
      label: "Rechazado",
      icon: "heroicons_solid:x-circle",
      color: "rgb(255, 0, 0)",
    },
  ];

  statusMaster = [
    {
      value: 1,
      label: "Activo",
      icon: "heroicons_solid:check-circle",
      color: "rgb(65, 106, 218)",
    },
    {
      value: 0,
      label: "Inactivo",
      icon: "heroicons_solid:x-circle",
      color: "rgb(141, 19, 19)",
    },
  ];

  statusLatence = [
    {
      value: "P",
      label: "En Progreso",
      icon: "heroicons_solid:play-circle",
      color: "rgb(236, 199, 58)",
    },
    {
      value: "S",
      label: "Exitoso",
      icon: "heroicons_solid:check-circle",
      color: "rgb(9, 133, 50)",
    },
    {
      value: "W",
      label: "Advertencia",
      icon: "heroicons_solid:exclamation-triangle",
      color: "rgb(255, 136, 0)",
    },
    {
      value: "E",
      label: "Error",
      icon: "heroicons_solid:x-circle",
      color: "rgb(141, 19, 19)",
    },
  ];

  bankType = [
    {
      value: "OWN",
      label: "PROPIO",
      icon: "heroicons_solid:play-circle",
      color: "rgb(236, 199, 58)",
    },
    {
      value: "EXTERNAL",
      label: "EXTERNO",
      icon: "heroicons_solid:check-circle",
      color: "rgb(9, 133, 50)",
    },
  ];

  statusGPS = [
    {
      value: 0,
      label: "Actualizados",
      icon: "heroicons_solid:check-circle",
      color: "rgb(9, 133, 50)",
    },
    {
      value: 1,
      label: "Pendientes",
      icon: "heroicons_solid:x-circle",
      color: "rgb(236, 199, 58)",
    },
  ];

  // Usar configuración centralizada para estados de viaje
  tripStatus = TRIP_STATUS_CONFIG.map((config) => ({
    value: config.value,
    label: config.longLabel,
    icon: config.icon,
    filterBgClass: config.filterBgClass,
    filterIconClass: config.filterIconClass,
  }));

  erpStatusCollections = [
    {
      value: 0,
      label: "Pendiente envío a ERP",
      icon: "heroicons_solid:clock",
      color: "rgb(233, 124, 61)",
    },
    {
      value: 1,
      label: "Enviado a ERP",
      icon: "heroicons_solid:document-arrow-up",
      color: "rgb(65, 106, 218)",
    },
    {
      value: 2,
      label: "Recibido por ERP",
      icon: "heroicons_solid:document-arrow-down",
      color: "rgb(236, 199, 58)",
    },
    {
      value: 3,
      label: "Creado en ERP",
      icon: "heroicons_solid:document-check",
      color: "rgb(9, 133, 50)",
    },
    {
      value: 4,
      label: "Error enviando a ERP",
      icon: "heroicons_solid:exclamation-triangle",
      color: "rgb(255, 0, 0)",
    },
    {
      value: 5,
      label: "Mod. pendiente de replicar",
      icon: "heroicons_solid:clock",
      color: "rgb(148, 46, 139)",
    },
    {
      value: 6,
      label: "Error en ERP",
      icon: "heroicons_solid:exclamation-triangle",
      color: "rgb(233, 124, 61)",
    },
  ];

  erpStatusCharges = [
    {
      value: 4,
      label: "Error en ERP",
      icon: "heroicons_solid:exclamation-triangle",
      color: "rgb(255, 0, 0)",
    },
    {
      value: 1,
      label: "Enviado a ERP",
      icon: "heroicons_solid:document-arrow-up",
      color: "rgb(65, 106, 218)",
    },
    {
      value: 0,
      label: "Pendiente envío a ERP",
      icon: "heroicons_solid:clock",
      color: "rgb(233, 124, 61)",
    },
    {
      value: 3,
      label: "Creado en ERP",
      icon: "heroicons_solid:document-check",
      color: "rgb(9, 133, 50)",
    },
  ];

  erpCustomerCollections = [
    {
      value: "BPT9002",
      label: "Cliente Eventual",
      icon: "person",
      color: "#2e7d32",
    },
    {
      value: "BPT9001",
      label: "CONSUMIDOR FINAL",
      icon: "person_outline",
      color: "#1976d2",
    },
    {
      value: "BPT0001",
      label: "CLIENTE",
      icon: "person_outline",
      color: "#2e7d32",
    },
    {
      value: "BPT0004",
      label: "NUEVO CLIENTE",
      icon: "person_outline",
      color: "#2e487dff",
    },
    {
      value: "BPT0003",
      label: "ENTREGADOR",
      icon: "person_outline",
      color: "#2e7d2eff",
    },
    {
      value: "BPT0002",
      label: "VENDEDOR",
      icon: "person_outline",
      color: "#2e7d2eff",
    },
  ];

  requestCreditType = [
    {
      value: true,
      label: "Extensión",
    },
    {
      value: false,
      label: "Solicitud",
    },
  ];

  routeFunction = [
    {
      code: SubRouteModelEnum.ENTREGA, //00
      name: "ENTREGA",
    },
    {
      code: SubRouteModelEnum.PREVENTA, //07
      name: "PREVENTA",
    },
  ];

  ngOnInit() {
    if (this.showStatusBankType) this.statusBankType = this.bankType;

    if (this.typeFilter === "gps") {
      this.statusOptions = this.statusGPS;
    } else {
      if (this.typeFilter === "latence") {
        this.statusOptions = this.statusLatence;
      } else {
        if (this.typeFilter === "master") {
          this.statusOptions = this.statusMaster;
          this.erpCustomerOptions = this.erpCustomerCollections.filter(
            (value) => this.showCustomerType.includes(value.value)
          );
        } else {
          if (this.typeFilter === "Charges") {
            this.statusOptions = this.statusCharges;
            this.erpStatusOptions = this.erpStatusCharges;
          } else {
            if(this.typeFilter === "TemporaryPassword"){
              this.statusOptions = this.statusTemporaryPassword;
            }else{
              this.statusOptions = this.statusChanges.filter((value) =>
                this.showStatus.includes(value.value)
              );

              this.erpStatusOptions = this.erpStatusCollections.filter((value) =>
                this.showERPStatus.includes(value.value)
              );

              this.erpCustomerOptions = this.erpCustomerCollections.filter(
                (value) => this.showCustomerType.includes(value.value)
              );

              this.statusNewBPOptions = this.statusNewBP.filter((value) =>
                this.showStatusNewBP.includes(value.value)
              );
            }
          }
        }
      }
      if (this.typeFilter === "tripStatus") {
        this.tripStatusOptions = this.tripStatus.filter((value) =>
          this.showTripStatuses.includes(value.value)
        );
      }

      if (this.typeFilter === "routeFunction") {
        this.routeFunctionOptions = this.routeFunction;
      }
    }

    this.tripStatusOptions = this.tripStatus.filter((value) =>
      this.showTripStatuses.includes(value.value)
    );

    this.routeFunctionOptions = this.routeFunction;
  }

  applyFilter() {
    this.selectionFilterApply.emit();
  }

  applyFilterTree(status) {
    this.selectionFilterApplyTree.emit(status);
  }

  isSelected(status: number): boolean {
    return this.selectedStatuses.includes(status);
  }
  //para el filtro de estados de viaje
  isTripStatusSelected(status: number): boolean {
    return this.selectedTripStatuses.includes(status);
  }
  //para el filtro de funcion de ruta
  isRouteFunctionSelected(name: string): boolean {
    return this.selectedRouteFunction.includes(name);
  }
  isSelectedTreeMode(status: string): boolean {
    return this.modeTree === status;
  }
  isSelectedTreeModeUnit(status: string): boolean {
    return this.modeTreeUnit === status;
  }

  isSelectedTreeModeMonitor(status: string): boolean {
    return this.modeTreeMonitor === status;
  }

  isNewBPSelected(status: number): boolean {
    return this.selectedStatusNewBP.includes(status);
  }

  isERPSelected(status: number): boolean {
    return this.selectedERPStatuses.includes(status);
  }

  isCustomerSelected(code: string): boolean {
    return this.selectedCustomerType.includes(code);
  }

  isBankTypeSelected(code: string): boolean {
    return this.selectedStatusesBankType.includes(code);
  }

  isRequestCreditSelected(status: boolean): boolean {
    return this.selectedStatusRequestCredit.includes(status);
  }

  toggleTripStatusSelection(status: number): void {
    const index = this.selectedTripStatuses.indexOf(status);
    if (index === -1) {
      this.selectedTripStatuses.push(status);
    } else {
      this.selectedTripStatuses.splice(index, 1);
    }
    this.applyFilter();
  }

  toggleSelection(status: number): void {
    const index = this.selectedStatuses.indexOf(status);
    if (index === -1) {
      this.selectedStatuses.push(status);
    } else {
      this.selectedStatuses.splice(index, 1);
    }

    this.applyFilter();
  }

  clearStatuses(): void {
    this.selectedStatuses.length = 0;
    this.applyFilter();
  }

  toggleSelectionTreeMode(
    status: "territory" | "salesOffice" | "group" | null = null
  ): void {
    this.modeTree = status;
    this.applyFilterTree(this.modeTree);
  }

  // En status-filters.component.ts - AGREGAR esta función
  toggleSelectionTreeModeUnit(status: "group" | null = null): void {
    this.modeTreeUnit = status;
    this.applyFilterTree(this.modeTreeUnit);
  }

  toggleSelectionTreeModeMonitor(status: "statusTrip" | null = null): void {
    this.modeTreeMonitor = status;
    this.applyFilterTree(this.modeTreeMonitor); // Usar método específico
  }

  toggleRouteFunctionSelection(name: string): void {
    const index = this.selectedRouteFunction.indexOf(name);
    if (index === -1) {
      this.selectedRouteFunction.push(name);
    } else {
      this.selectedRouteFunction.splice(index, 1);
    }
    this.applyFilter();
  }

  toggleSelectionNewBP(status: number): void {
    const index = this.selectedStatusNewBP.indexOf(status);
    if (index === -1) {
      this.selectedStatusNewBP.push(status);
    } else {
      this.selectedStatusNewBP.splice(index, 1);
    }

    this.applyFilter();
  }

  toggleERPSelection(status: number): void {
    const index = this.selectedERPStatuses.indexOf(status);
    if (index === -1) {
      this.selectedERPStatuses.push(status);
    } else {
      this.selectedERPStatuses.splice(index, 1);
    }

    this.applyFilter();
  }

  clearERPStatuses(): void {
    this.selectedERPStatuses.length = 0;
    this.applyFilter();
  }

  toggleCustomerSelection(code: string): void {
    const index = this.selectedCustomerType.indexOf(code);
    if (index === -1) {
      this.selectedCustomerType.push(code);
    } else {
      this.selectedCustomerType.splice(index, 1);
    }

    this.applyFilter();
  }

  clearCustomerTypes(): void {
    this.selectedCustomerType.length = 0;
    this.applyFilter();
  }

  toggleBankTypeSelection(code: string): void {
    const index = this.selectedStatusesBankType.indexOf(code);
    if (index === -1) {
      this.selectedStatusesBankType.push(code);
    } else {
      this.selectedStatusesBankType.splice(index, 1);
    }

    this.applyFilter();
  }

  toggleRequestCreditSelection(code: boolean): void {
    const index = this.selectedStatusRequestCredit.indexOf(code);
    if (index === -1) {
      this.selectedStatusRequestCredit.push(code);
    } else {
      this.selectedStatusRequestCredit.splice(index, 1);
    }

    this.applyFilter();
  }

  //Lo agregue para que se pueda mostrar el label del status diferente en maestros
  getStatusLabel(value: number): string {
    return value === 0 && this.typeFilter === "master" ? "Inactivo" : "Anulado";
  }

  getStatusLabelNewBP(status: number): string {
    const labels: { [key: number]: string } = {
      [StatusBusinessPartnerEnum.APPROVED]: "Registro Aprobado",
      [StatusBusinessPartnerEnum.PENDING]: "Pendiente",
      [StatusBusinessPartnerEnum.IN_PROCESS]: "En proceso de aprobación",
      [StatusBusinessPartnerEnum.REJECTED]: "Rechazado",
    };
    return labels[status] || "Desconocido";
  }

  getTripStatusConfig(statusId: number) {
    return getTripStatusConfig(statusId);
  }
}